<button type="button" [ngClass]="btnClass" (click)="onClick($event)">
    {{ label }}
</button>